/** Categorias de serviço do catálogo Agrada (Configuração → Planos). */
export const SERVICE_INTEREST_CATEGORIES = [
  'Marketing',
  'Desenvolvimento',
  'Consultoria',
  'Rocket Search',
  'Suporte',
  'Módulos Adicionais',
  'Outro',
] as const

export type ServiceInterestCategory = (typeof SERVICE_INTEREST_CATEGORIES)[number]
